/* eslint-disable prefer-destructuring */
import { h, render } from 'preact';
import { useProduct } from './product-context';

const FitSelector = () => {
  const {
    handleFitChange,
    sizeOptions,
    selectedFit,
  } = useProduct();

  const values = sizeOptions?.values;
  const hasTallSizes = values?.some((value) => value.toLowerCase().includes('-tall'));

  if (!hasTallSizes) return null;

  return (
    <div id="fitselector">
      <div className="text-[14px] leading-[18px] mb-[6px] flex justify-between">
        <div className="uppercase">
          Fit <span className="capitalize text-text-2">{selectedFit.replace('-', ' ')}</span>
        </div>
      </div>
      <div className="min-h-[44px] grid grid-cols-4 gap-x-[10px] mb-[30px]">
      <button
        className={`border-grey-400 bg-white text-black ${
          selectedFit === 'regular' && 'border-text-1 bg-text-1 text-white'
        } flex items-center justify-center h-[44px] rounded-md text-sm border`}
        onClick={() => handleFitChange('regular')}
      >
        Regular
      </button>
      <button
        className={`border-grey-400 bg-white text-black ${
          selectedFit === 'long-torso' && 'border-text-1 bg-text-1 text-white'
        } flex items-center justify-center h-[44px] rounded-md text-sm border`}
        onClick={() => handleFitChange('long-torso')}
      >
        Long Torso
      </button>
      </div>
    </div>
  );
};

export default FitSelector;
